/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyWheel.vue?vue&type=template&id=0c8e272a"
import script from "./luckyWheel.vue?vue&type=script&lang=js"
export * from "./luckyWheel.vue?vue&type=script&lang=js"
import style0 from "./luckyWheel.vue?vue&type=style&index=0&id=0c8e272a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports